export default "__VITE_ASSET__Bfm$B6PN__"